export class ResetPasswordModel
{
    public user_id: string;
    public reset_id: string;
    public password: string;
    public is_link_expired: boolean;
    public user_email: string;
    public client_id: string;
}
